import img1 from "../assets/1.png"
import img2 from "../assets/2.png"
import img3 from "../assets/3.png"
import img4 from "../assets/4.png"
import img5 from "../assets/5.png"
import img6 from "../assets/6.png"
import img7 from "../assets/7.png"
import img8 from "../assets/8.png"

const Data = [
  {
    id: 1,
    date: "1 марта 2024",
    destination: "Отпуск в Намангане, Узбекистан",
    description: "Городской бассейн 'Зеленая Оазис' - отличное место для купаний и парти.",
    image: img1,
    moreDescription: "Во время этого отпуска вы сможете насладиться не только красивыми природными местами, но и погрузиться в атмосферу города, посетив местные достопримечательности и рестораны. Гарантирован отдых и веселье!",
  },
  {
    id: 2,
    date: "15 апреля 2024",
    destination: "Летний отдых в Намангане: Горы и равнины",
    description: "Чарвакское водохранилище - красивое место для активного отдыха и прогулок.",
    image: img2,
    moreDescription: "Этот отдых предоставит вам возможность насладиться живописными горами и равнинами, познакомиться с местной культурой и традициями. Подходит как для любителей природы, так и для активного отдыха.",
  },
  {
    id: 3,
    date: "10 июня 2024",
    destination: "Летний отдых в Намангане: По следам современных городов",
    description: "Национальный комплекс 'Аксарай' - уникальное место с остатками древних поселений.",
    image: img3,
    moreDescription: "Исследуйте интересные места современного города, посещая музеи, архитектурные памятники и местные магазины. Отличное сочетание культурного опыта и отдыха.",
  },
  {
    id: 4,
    date: "5 августа 2024",
    destination: "Летний курорт в Намангане: Отдых на берегу озера Аядаркуль",
    description: "Отличное место для отдыха и для приключений",
    image: img4,
    moreDescription: "Проведите время у берега озера, наслаждаясь природой и активными видами отдыха, такими как водные виды спорта и прогулки по окрестностям озера.",
  },
  {
    id: 5,
    date: "15 сентября 2024",
    destination: "Летние краски Намангана: Путешествие по пляжам",
    description: "Пляжи вокруг Намангана прекрасны летом. Идеальное место для треккинга и наслаждения водой и песками.",
    image: img5,
    moreDescription: "Отправьтесь на путешествие по лучшим пляжам Намангана, наслаждаясь морским воздухом и удивительными видами. Отличное место для релаксации и забыть о повседневных заботах.",
  },
  {
    id: 6,
    date: "1 ноября 2024",
    destination: "Наманган в ноябре: Праздник света и красок",
    description: "Участвуйте в местных праздниках и наслаждайтесь красочными огнями и культурными мероприятиями.",
    image: img6,
    moreDescription: "Погрузитесь в атмосферу местных традиций и праздничной магии в ноябре. Участвуйте в праздничных мероприятиях и наслаждайтесь красивыми огоньками.",
  },
  {
    id: 7,
    date: "20 декабря 2024",
    destination: "Летний отдых в Намангане: Закат и Море",
    description: "Песчаный курорт в окрестностях Намангана приглашает насладиться осенними развлечениями.",
    image: img7,
    moreDescription: "Отправьтесь в путешествие в декабре и наслаждайтесь пляжами и морскими видами в окрестностях Намангана. Переживите уникальные моменты в холодное время года.",
  },
  {
    id: 8,
    date: "10 января 2025",
    destination: "Новогодние праздники в Намангане",
    description: "Погрузитесь в атмосферу праздничных гуляний и праздничной иллюминации в центре города.",
    image: img8,
    moreDescription: "Освежите себя новогодней магией и праздничной атмосферой. Насладитесь украшениями и мероприятиями, проводимыми в городе в период новогодних праздников.",
  },
]
export default Data